import { gql } from "@apollo/client";

export const IGNORE_ACTION_ITEM = gql`
  mutation ignoreActionItem($id: ID!, $paymentType: String, $actionItemType: String) {
    ignoreActionItem(id: $id, paymentType: $paymentType, actionItemType: $actionItemType)
  }
`;